import { render, staticRenderFns } from "./InnerActItems.vue?vue&type=template&id=31d6a632"
import script from "./InnerActItems.vue?vue&type=script&lang=js"
export * from "./InnerActItems.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports